<template>
  <b-container :fluid="fluid">
    <div class="content-card">
      <slot />
    </div>
  </b-container>
</template>
<script>
export default {
  props: {
    fluid: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
